import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
const FaqAccordionRow = ({ item, activeLang, isOpen, onToggle }) => {
    const { t } = useTranslation();
    const reactId = useId();
    // Defensive narrowing — the parent filter guarantees `available === true`
    // but the discriminated union requires this for type-safety of question/answer.
    // All hooks above this point so the early return does not violate rules-of-hooks.
    const tx = item.translations[activeLang];
    if (!tx.available) {
        return null;
    }
    const buttonId = `faq-row-button-${reactId}`;
    const answerId = `faq-row-answer-${reactId}`;
    return (_jsxs("article", { className: `faq-accordion-row${isOpen ? ' faq-accordion-row--opened' : ''}`, children: [_jsxs("button", { type: "button", id: buttonId, className: "faq-accordion-button", "aria-expanded": isOpen, "aria-controls": answerId, onClick: () => onToggle(item.uid), children: [_jsx("span", { className: "faq-accordion-question", children: tx.question }), _jsx("span", { className: "faq-accordion-toggle", children: isOpen
                            ? t('faq.toggle.hide')
                            : t('faq.toggle.show') })] }), isOpen && (_jsx("div", { id: answerId, role: "region", "aria-labelledby": buttonId, className: "faq-answer text-content", dangerouslySetInnerHTML: { __html: tx.answer } }))] }));
};
export default FaqAccordionRow;
